import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";

export default class DashboardNumberChartMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();
    }

    destroy() {
        super.destroy();
    }

    setArrow(increase, positive) {
        if (increase) {
            this._target.Trend.gotoAndStop(positive ? 2 : 1);
        } else {
            this._target.Trend.gotoAndStop(positive ? 3 : 0);
        }
    }

    setData(dashboardSingleData, showTrend = true) {
        this._target.DataTitleTextField.text = dashboardSingleData.description;
        this._target.DataNrTextField.text = dashboardSingleData.number;
        if (!showTrend) {
            this._target.TrendIndicatorGoodTextField.alpha = 0;
            this._target.TrendIndicatorBadTextField.alpha = 0;
            this._target.Trend.alpha = 0;
            return
        }
        this._target.TrendIndicatorGoodTextField.alpha = positive ? dashboardSingleData.percent : 0;
        this._target.TrendIndicatorBadTextField.alpha = positive ? 0 : dashboardSingleData.percent;
        this.setArrow(dashboardSingleData.increase, dashboardSingleData.positive);
    }
}